import type { InvoiceListSort, ListSort } from '@/api/types'

export const SORT_PARAM = 'sort'
export const SORT_LABEL = 'Sortering'

export interface SortOption<TSort extends string> {
  value: TSort
  label: string
}

export const DEFAULT_SORT: ListSort = 'newest'

export const LIST_SORT_OPTIONS: SortOption<ListSort>[] = [
  { value: 'newest', label: 'Nyast först' },
  { value: 'oldest', label: 'Äldst först' }
]

export const INVOICE_SORT_OPTIONS: SortOption<InvoiceListSort>[] = [...LIST_SORT_OPTIONS, { value: 'due_date', label: 'Förfaller först' }]

export function findSortOption<TSort extends string>(options: SortOption<TSort>[], value: string | null): SortOption<TSort> | undefined {
  return options.find((option) => option.value === value)
}

// Ett okänt värde i en handredigerad URL ger standardsorteringen i stället för ett 400 från backend.
export function parseSort<TSort extends string>(params: URLSearchParams, options: SortOption<TSort>[], fallback: TSort): TSort {
  const option = findSortOption(options, params.get(SORT_PARAM))

  return option?.value ?? fallback
}

// Standardsorteringen utelämnas så att URL:en bara innehåller det som avviker.
export function writeSort(params: URLSearchParams, sort: string): void {
  params.delete(SORT_PARAM)

  if (sort !== DEFAULT_SORT) {
    params.set(SORT_PARAM, sort)
  }
}
